import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse, IInvoicingInformation } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'projectPricingCategorys'

const filter = (axios: IFactoryFunctionRequest<Array<any>, undefined>) => ({
  page = 0,
  display = '',
  limit = 30,
}: { page?: number; display?: string; limit?: number }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, display, limit },
  })
}

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

const createProjectPricingCategory = (axios: IFactoryFunctionRequest<any, any>) => (data: any) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const updateProjectPricingCategory = (axios: IFactoryFunctionRequest<any, any>) => (id: string, { data }: { data: any }) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
    data,
  })
}

const deleteProjectPricingCategory = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  filter: filter(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  create: createProjectPricingCategory(useAxios(axios)),
  update: updateProjectPricingCategory(useAxios(axios)),
  delete: deleteProjectPricingCategory(useAxios(axios)),
})
